// Auto-extracted from lib/i18n.js on refactor — do not hand-edit if you
// can help it; keep the same style + comment layout as the other dicts.
const ar = {
    // Common
    appName: "JobGrid",
    tagline: "متعقب سولنك الشخصي",
    appliedStatus: "تم التقديم",
    savedStatus: "لم يُقدَّم بعد",
    invitedStatus: "مدعو",
    rejectedStatus: "مرفوض",
    channelLinkedIn: "لينكدإن",
    channelRecruiter: "وسيط توظيف",
    channelOpen: "طلب مفتوح",
    typeIncompany: "دوام كامل",
    typeFreelance: "عمل حر",
    typeOutsourced: "تعاقد",
    rateHourly: "بالساعة",
    rateDaily: "باليوم",
    rateMonthly: "بالشهر",
    cancel: "إلغاء",
    save: "حفظ",
    saving: "يتم الحفظ…",
    add: "إضافة",
    edit: "تعديل",
    view: "عرض",
    delete: "حذف",
    logout: "تسجيل الخروج",
    loading: "جارٍ التحميل…",
    confirmTitle: "هل أنت متأكد؟",
    confirmConfirm: "تأكيد",
    confirmCancel: "إلغاء",
    all: "الكل",

    // Landing / Login page
    loginEdition: "الجزء الثاني · من الشاغر إلى العرض",
    loginBody: "ابحث عن الوظائف عبر لينكدإن وإنديد وأدزونا وجوببيرد وغيرها — اختر واحدة واكتب رسالة تحفيزية بالذكاء الاصطناعي في ثوانٍ. تتكيف سيرتك تلقائيًا، وتجهيز المقابلة جاهز عند الحاجة. كل شيء في مكان هادئ واحد، ومجاني للبدء.",
    loginContinueGoogle: "المتابعة عبر جوجل",
    loginGoogleSignin: "تسجيل الدخول بجوجل",
    loginGoogleRegister: "التسجيل بجوجل",
    emailAuthOr: "أو عبر البريد الإلكتروني",
    emailAuthEmail: "البريد الإلكتروني",
    emailAuthPassword: "كلمة المرور",
    emailAuthLoginCta: "تسجيل الدخول",
    emailAuthRegisterCta: "إنشاء حساب",
    emailAuthForgotLink: "نسيت كلمة المرور؟",
    emailAuthRegisterLink: "ليس لديك حساب؟",
    emailAuthBackToLogin: "العودة لتسجيل الدخول",

    // Navigation (landing + dashboard)
    landNavPricing: "الأسعار",
    landNavPartner: "شركاء",
    footerContact: "اتصل بنا",
    navProductTour: "جولة المنتج",
    navTour: "جولة",
    navProfile: "ملفك الشخصي",
    navFeedback: "دعم",
    navRecommend: "توصية",

    // Hero (landing)
    landH1a: "من",
    landH1accent: "شاغر",
    landH1b: "مباشرة إلى",
    landH1accent2: "خطاب تحفيزي",
    landH1c: "— عبر",
    landH1accent3: "سيرة",
    landH1d: "تتطابق. في تطبيق واحد هادئ.",
    landSub: "ابحث عن الوظائف عبر لينكدإن وإنديد وأدزونا وجوببيرد — اختر واحدة واكتب رسالة تحفيزية بالذكاء الاصطناعي في ثوانٍ.",
    landCtaPricing: "الخطط والأسعار",

    // Tour modal + preview
    tourEyebrow: "جولة المنتج · قصيرة ومركزة",
    tourClipCv: "منشئ السيرة",
    tourClipLetter: "خطاب التحفيز",
    tourClipInterview: "مدرب المقابلات",
    tourClipRadar: "رادار التطابق",
    tourSoon: "قريبًا",
    tourClipComingSoon: "هذا المقطع في الطريق.",
    tourFooterHint: "اضغط Escape للإغلاق · جميع المقاطع مترجمة",
    tourCloseCta: "تم",
    tourEndTitle: "جاهز للبدء بنفسك؟",
    tourEndBody: "أنشئ حسابك المجاني وابنِ سيرتك الأولى في 3 دقائق.",
    tourStartFreeCta: "ابدأ مجانًا",
    tourGoDashCta: "افتح لوحة التحكم",
    tourReplayCta: "شاهد مرة أخرى",
    tourShareCopy: "نسخ الرابط",
    tourShareCopied: "تم النسخ!",
    landTourBadge: "جديد · جولة فيديو",
    landTourBannerBody: "شاهد في دقيقة كيف تبني سيرة موجّهة.",
    landTourCta: "شاهد الجولة",
    landTourPreviewEyebrow: "جولة المنتج · نظرة سريعة",
    landTourPreviewTitle: "شاهد ما ستحصل عليه — 4 مقاطع، 20 ثانية لكلٍّ منها",
    landTourPreviewHint: "اضغط على أي بلاطة لمشاهدة المقطع فورًا",

    // Language switcher
    languageLabel: "اللغة",
    languageUiSection: "لغة التطبيق",
    languageAiSection: "الذكاء الاصطناعي يولّد بـ 8 لغات",
    languageAiHint: "احتفظ بسيرتك بالعربية وأنشئ الخطاب بأي لغة تريدها.",

    // Two-factor (short set)
    tfaEyebrow: "الأمان",
    tfaTitle: "التحقق بخطوتين",
    tfaBody: "فعّل التحقق بخطوتين ليطلب التطبيق رمزًا مؤقتًا من تطبيق المصادقة عند كل تسجيل دخول.",
    tfaStatusOn: "التحقق بخطوتين مُفعّل",
    tfaStatusOff: "التحقق بخطوتين غير مُفعّل",
    tfaEnableBtn: "تفعيل التحقق بخطوتين",
    tfaDisableBtn: "إيقاف التحقق بخطوتين",
    tfaConfirmBtn: "تأكيد وتفعيل",
    tfaCopyAll: "نسخ جميع الرموز",
    tfaBackupHide: "لقد حفظتها — إخفاء",

    // Profile tabs / affiliate
    affTabLabel: "شركاء",
    affPosterAttribution: "النقرات لكل ملصق",
    affPosterAttributionHint: "رمز QR على كل ملصق مُوسم لكل نمط، لذا سترى بالضبط أيهم يجلب أفضل نتيجة.",
    affPosterClassic: "كلاسيكي A4",
    affPosterBanner: "بانر A4",
    affPosterQuote: "اقتباس A4",
    affPosterClicksUnit: "إجمالي النقرات",
    affPosterConversionsUnit: "تحويل",
    affPosterCvrUnit: "معدل التحويل",
    affPosterWinnerLabel: "الفائز · {v}",
    affPosterWinnerHint: "أعلى معدل تحويل في الفترة الحالية. اطبع هذا النمط أولاً.",
    affStatClicks7d: "النقرات (7 أيام)",
    affStatConversions: "التحويلات",
    affStatAccrued: "متراكم",
    affStatPaid: "مدفوع",

    // Pricing
    priceCta: "اختر هذه الخطة",
    priceCtaFree: "فعّل الخطة المجانية",
    priceMostPopular: "الأكثر اختيارًا",
    priceCheckoutFailed: "فشل الدفع",

    // AI Match Insight (job detail sheet)
    miEyebrow: "تحليل التوافق بالذكاء الاصطناعي · لماذا تناسبك؟",
    miVerdict_strong: "توافق قوي",
    miVerdict_good: "توافق جيد",
    miVerdict_mixed: "توافق متوسط",
    miVerdict_weak: "توافق ضعيف",
    miStrengthsHeader: "ما يعمل لصالحك",
    miGapsHeader: "نقاط تستحق الانتباه",
    miRefreshBtn: "أعِد التوليد",
    miRefreshHint: "أنشئ ملخصًا جديدًا بالذكاء الاصطناعي بناءً على سيرتك الحالية",
    miGeneratedAt: "تم التوليد في",
    miErrGeneric: "تعذّر الحصول على التحليل — حاول مجددًا لاحقًا.",
    similarStripEyebrow: "قد يعجبك أيضًا · وظائف بدرجة مقاربة",
    similarStripHint: "هذه الوظيفة تحصل على {s}/100. وظائف مماثلة في قائمتك:",

    // Jobs overview — sort + match column
    dashLabelSort: "ترتيب حسب",
    dashSortRecent: "التاريخ · الأحدث أولًا",
    dashSortOldest: "التاريخ · الأقدم أولًا",
    dashSortMatchDesc: "درجة التوافق · من الأعلى إلى الأدنى",
    dashSortMatchAsc: "درجة التوافق · من الأدنى إلى الأعلى",
    dashColMatch: "التوافق",
    dashColMatchHint: "درجة توافق مبنية على سيرتك الذاتية مقارنةً بالوظيفة. اضغط على الصف لرؤية التحليل الكامل.",
    dashMatchNotYet: "افتح هذه الوظيفة لتوليد تحليل توافق بالذكاء الاصطناعي",
    dashBulkInsightsBtn: "تحاليل الذكاء الاصطناعي للكل",
    dashBulkInsightsBusy: "جارٍ التوليد…",
    dashBulkInsightsHint: "توليد درجة توافق لكل وظيفة نشطة لا تحمل واحدة بعد (حتى 15 لكل نقرة).",
    dashBulkInsightsDone: "تم توليد {n} تحليلات",
    dashBulkInsightsMore: "لا يزال هناك {n} وظائف",
    dashBulkInsightsAlerts: "تم إرسال {n} تنبيهات توافق قوي",
    dashBulkInsightsFailed: "فشل التوليد المجمّع — حاول لاحقًا.",
    prefMatchAlertsEyebrow: "تنبيهات التوافق القوي",
    prefMatchAlertsTitle: "أرسل بريدًا عند بلوغ درجة التوافق الحدّ",
    prefMatchAlertsBody: "بمجرد أن نجد وظيفة تناسبك، نرسل بريدًا مختصرًا بالدرجة وأهم الأسباب. لكل وظيفة تنبيه واحد كحدٍّ أقصى.",
    prefMatchAlertsToggle: "تفعيل التنبيهات",
    prefMatchAlertThreshold: "حدّ التنبيه",
    prefMatchAlertSaved: "تم الحفظ",

    // Auto-cue teleprompter
    vidAutoCueEyebrow: "قارئ آلي — اقرأ معنا",
    vidAutoCueStart: "ابدأ",
    vidAutoCuePause: "إيقاف مؤقت",
    vidAutoCueRedo: "من البداية",

    // QR-code hint on success screen
    vidQrEyebrow: "رمز QR على رسالة الدافع",
    vidQrHint: "نُضيف تلقائيًا رمز QR في تذييل رسالة الدافع (PDF). يُلوّح المُوظِّف بهاتفه فيصل مباشرةً إلى فيديو تعريفك.",

    // Elevator-pitch mode
    vidElevatorTitle: "المصعد · فيديو تعريفي عام",
    vidElevatorEyebrow: "فيديو تعريفي",
    vidElevatorCardTitle: "سجّل فيديو ٦٠ ثانية لمرة واحدة",
    vidElevatorCardBody: "يُربط هذا الفيديو تلقائيًا كرمز QR بسيرتك الذاتية وبكل رسالة دافع لا تحتوي فيديو خاصًا بها.",
    vidElevatorCta: "سجّل فيديو تعريفي",
    vidElevatorReplace: "استبدل الفيديو التعريفي",
    vidElevatorHasOne: "فيديو تعريفي نشط — شُوهد {views} مرة.",
    vidViewCount: "شُوهد {n} مرة من قبل الموظِّفين",

    // Custom QR-label
    vidQrLabelTitle: "نص رمز QR على الـPDF",
    vidQrLabelHint: "يظهر هذا النص أسفل رمز QR على سيرتك الذاتية ورسالة الدافع. اتركه فارغًا لاستخدام النص الافتراضي.",
    vidQrLabelPlaceholder: "مثال: شاهد فيديو تعريفي في ٦٠ ثانية",
    vidQrLabelSave: "حفظ",
    vidQrLabelSaving: "جارٍ الحفظ…",
    vidQrLabelSaved: "تم حفظ نص QR",
    vidQrLabelFail: "فشل حفظ نص QR",

    // References multi-select
    rbRefPickPh: "اختر المراجع — أو اترك فارغًا لعرض 'المراجع عند الطلب'",
    rbRefSelectedCount: "تم اختيار {n} مرجع/مراجع",
    rbRefRemove: "إزالة",
    rbRefLoading: "جارٍ التحميل…",
    rbRefEmpty: "لا توجد مراجع معتمدة بعد. أضفها من الإعدادات → المراجع.",
    rbRefAllPicked: "تم اختيار جميع المراجع المتاحة.",
    rbRefDefault: "بدون اختيار → ستُعرض 'المراجع عند الطلب' على PDF.",
    rbRefSelectedHint: "تظهر فقط الحقول التي وافق المرجع على مشاركتها في الـPDF.",
    rbRefDragHint: "اسحب لإعادة الترتيب",
    rbSkillDragHint: "اسحب لترتيب المهارات — الأولى تظهر في المقدمة على السيرة الذاتية",
    rbRefPreviewEyebrow: "معاينة — هكذا ستظهر على PDF",
    rbRefPreviewDefault: "المراجع متوفرة عند الطلب",

    // PopoutTextarea
    popoutTitle: "تحرير",
    popoutExpand: "توسيع المحرر",
    popoutSave: "حفظ",
    popoutCancel: "إلغاء",
    popoutSaved: "تم الحفظ",
    popoutShortcut: "⌘/Ctrl + Enter = حفظ",
    popoutChars: "{n} حرف",

    // Skip-keywords blocklist
    jsSkipTitle: "كلمات التصفية — إخفاء الوظائف بهذه المتطلبات",
    jsSkipHint: "أضِف كلمات أو عبارات قصيرة لا تريد رؤيتها في الوظائف. تُخفى الوظائف التي تحتوي على أي من هذه الكلمات في العنوان أو الوصف.",
    jsSkipCount: "{n} كلمة نشطة",
    jsSkippedBadge: "{n} مخفية في هذا البحث",
    jsSkipPlaceholder: "مثال: HBO",
    jsSkipAdd: "إضافة",
    jsSkipRemove: "إزالة",
    jsSkipSaveFail: "فشل الحفظ",
    jsSkipSugInsightsTitle: "اقتراحات الذكاء الاصطناعي من تحليلات no_fit",
    jsSkipSugInsightsHint: "الفجوات المتكررة في تحليلات التوافق",
    jsSkipSugCvTitle: "الفجوات مقارنةً بسيرتك",
    jsSkipSugCvHint: "المصطلحات المتكررة في الوظائف وغير الموجودة في سيرتك",
    jsSkipSugLoading: "جارٍ حساب الاقتراحات…",
    jsSkipSugDismiss: "لا تقترح مجددًا",
    jsSkipReasonTitle: "لماذا أُخفيت هذه الوظائف",
    jsSkipReasonMatched: "طابقت الكلمة/الكلمات:",

    profSkipTitle: "الاقتراحات المرفوضة",
    profSkipHint: "الاقتراحات التي طلبت عدم عرضها مرة أخرى بالضغط على ×. اضغط على ↺ لجعلها متاحة مجددًا.",
    profSkipCount: "{n} مرفوضة",
    profSkipLoading: "جارٍ التحميل…",
    profSkipEmpty: "لم يتم رفض أي اقتراحات بعد.",
    profSkipUndo: "تراجع — اسمح باقتراحها مجددًا",
    profSkipUndone: "\"{kw}\" أصبح متاحًا مجددًا",
    profSkipUndoFail: "فشل التراجع",

    // Skip history tab
    jsTabHistory: "السجل",
    jsHistoryTitle: "الوظائف المُخفاة — السجل",
    jsHistoryCount: "{n} صف",
    jsHistoryClear: "امسح السجل",
    jsHistoryClearConfirm: "هل تريد بالتأكيد مسح سجل الإخفاء بأكمله؟",
    jsHistoryCleared: "تم مسح السجل",
    jsHistoryClearFail: "فشل المسح",
    jsHistoryLoading: "جارٍ تحميل السجل…",
    jsHistoryEmptyTitle: "لا شيء مخفي بعد",
    jsHistoryEmptyHint: "بمجرد أن يُخفي البحث وظائف بناءً على كلماتك، ستظهر هنا.",
    jsHistoryDate: "التاريخ",
    jsHistoryQuery: "البحث",
    jsHistoryJob: "الوظيفة",
    jsHistoryMatched: "المطابقة",
    jsHistoryOpenTip: "انقر لفتح هذه الوظيفة على أي حال",

    // ThinkingLoader — playful rotating status copy for long AI tasks.
    thinkMatch1: "أقرأ سيرتك الذاتية بعناية…",
    thinkMatch2: "أُحصي مهاراتك…",
    thinkMatch3: "أستعرض الوظائف واحدة تلو الأخرى…",
    thinkMatch4: "ألتقط قلمي الأحمر…",
    thinkMatch5: "أحسب درجات التوافق…",
    thinkMatch6: "نظرة ثانية سريعة…",
    thinkMatch7: "على وشك الانتهاء — اللمسات الأخيرة…",

    thinkLetter1: "أُحلّل الوظيفة…",
    thinkLetter2: "أستخرج نقاط قوتك…",
    thinkLetter3: "أضبط النبرة والأسلوب…",
    thinkLetter4: "أصقل الجُمل…",
    thinkLetter5: "أُنظّم الفقرات…",
    thinkLetter6: "لمسات أخيرة على الرسالة…",

    thinkPrep1: "أبحث عن الشركة…",
    thinkPrep2: "أستكشف الرسالة والثقافة…",
    thinkPrep3: "أُعدّ أسئلة مقابلة ذكية…",
    thinkPrep4: "أُجهّز إجابات بأسلوب STAR…",
    thinkPrep5: "أرصد المزالق المحتملة…",
    thinkPrep6: "أُصمّم نصائح كوتشينغ مخصّصة…",

    thinkInsight1: "أفحص نص الوظيفة…",
    thinkInsight2: "أُحدّد نقاط قوتك…",
    thinkInsight3: "أُشير إلى الفجوات…",
    thinkInsight4: "أصوغ الحكم النهائي…",
    thinkInsight5: "اقتربنا — الرؤية جاهزة تقريبًا…",

    thinkBulk1: "أجمع الوظائف…",
    thinkBulk2: "أحسب توافق كل وظيفة…",
    thinkBulk3: "الذكاء الاصطناعي يعمل — قد يستغرق لحظات…",
    thinkBulk4: "لحظة، وظائف متعددة في وقت واحد…",
    thinkBulk5: "أُعدّ التقرير…",
    thinkBulk6: "قريبًا — أُجمّع النتائج…",

    thinkResume1: "أُنظّم الخبرات والمهارات…",
    thinkResume2: "أكتب نقاطًا قوية…",
    thinkResume3: "أصقل اللغة…",
    thinkResume4: "أحذف الكلمات الزائدة…",
    thinkResume5: "أراجع البنية وفق أفضل الممارسات…",
    thinkResume6: "لمسات أخيرة على السيرة…",

    thinkEmail1: "أختار النبرة والتحية…",
    thinkEmail2: "ألخّص الرسالة الأساسية…",
    thinkEmail3: "أصقل الجُمل…",
    thinkEmail4: "قبل الإرسال — لحظة واحدة…",

    thinkGeneric1: "لحظة من فضلك — أعمل على ذلك…",
    thinkGeneric2: "خطوة أو خطوتان بعد…",
    thinkGeneric3: "أوشكنا…",
    thinkGeneric4: "أبذل قصارى جهدي — قريبًا…",
    thinkGeneric5: "قليلًا بعد…",
};

export default ar;
